import React, { Component, Fragment } from 'react';
import StripeDefaultCardSelector from 'selectors/StripeDefaultCardSelector';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import SecuredCheckout from 'components/SecuredCheckout';

import './style.css';

class CartSummary extends Component {
  renderPrices() {
    const { currentPlan, selectedPlan, proration } = this.props;

    if (currentPlan && currentPlan.id === selectedPlan.id) {
      return null;
    }

    return (
      <Fragment>
        <li className="list-group-item px-0 py-4">
          <div>
            {selectedPlan.isPrepaid ? (
              <div>
                New plan (6 months): <strong>${selectedPlan.price.total}</strong>
              </div>
            ) : (
              <div>
                New plan (monthly): <strong>${selectedPlan.price.month}</strong>
              </div>
            )}
            {typeof proration.credit === 'number' && (
              <div>
                Prorated credit: {proration.credit < 0 ? '-' : ''}${Math.abs(proration.credit)}
              </div>
            )}
          </div>
        </li>
        {typeof proration.dueNow === 'number' && (
          <li className="list-group-item px-0 py-4">
            <div>
              Amount due: {proration.dueNow < 0 ? '-' : ''}${Math.abs(proration.dueNow)}
            </div>
          </li>
        )}
      </Fragment>
    );
  }

  renderPaymentMethod() {
    const { defaultCard } = this.props;
    const name = defaultCard ? `Visa ending in ${defaultCard.last4}` : 'No active payment method';
    const buttonText = defaultCard ? 'Edit' : 'Add';

    return (
      <Fragment>
        {name}
        <Link className="d-block" to="/profile/plans-and-billing/cards">
          {buttonText}
        </Link>
      </Fragment>
    );
  }

  render() {
    const {
      currentPlan, defaultCard, selectedPlan, onUpdate, isUpdatingPlan
    } = this.props;

    if (!currentPlan && !selectedPlan) return null; // This is basically the loading state

    const enableUpdate =
      selectedPlan &&
      selectedPlan.currentlyOffered &&
      (!currentPlan || selectedPlan.id !== currentPlan.id) &&
      defaultCard;

    const planToShow = selectedPlan || currentPlan;
    const selectedCycleText = planToShow.isAnnual ? 'Annual (12 montly payments)' : 'Paid monthly';
    const planNameText = `${planToShow.limit} hours/mo`;

    return (
      <div id="cart-summary" className="cart-summary card px-4 mb-3">
        <ul className="list-group list-group-flush">
          <li className="list-group-item px-0 py-4">
            <div>
              <h5 className="cart-summary__title mt-1">{planNameText}</h5>
              {selectedCycleText && <div className="text-brown">{selectedCycleText}</div>}
            </div>
          </li>

          <li className="list-group-item justify-content-between px-0 py-4">
            {this.renderPaymentMethod()}
          </li>

          {selectedPlan && this.renderPrices()}

          <li className="list-group-item list-group-item__with-btn px-0 py-4">
            <button
              type="button"
              className="btn btn-primary btn-block btn-cursor"
              disabled={!enableUpdate || isUpdatingPlan}
              onClick={onUpdate}
            >
              Update
            </button>
            <SecuredCheckout className="cart-summary__secure-text" />
          </li>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    defaultCard: StripeDefaultCardSelector(state),
    proration: state.stripeProration
  };
}

export default connect(mapStateToProps)(CartSummary);



// WEBPACK FOOTER //
// ./src/pages/student/Profile/routes/LowerTierPlan/CartSummary/index.js